<script lang="ts">
  import type { HTMLLabelAttributes } from "svelte/elements";
  import type { Snippet } from "svelte";
  import { cn } from "$lib/utils/cn";

  type Props = HTMLLabelAttributes & {
    class?: string;
    children?: Snippet;
    required?: boolean;
  };

  const { class: className, required, children, ...rest }: Props = $props();
</script>

<label class={cn("mb-1.5 flex flex-wrap items-center gap-x-1 gap-y-0.5 text-sm font-medium text-(--surface-fg)", className)} {...rest}>
  {@render children?.()}
  {#if required}
    <span class="text-(--surface-danger)" aria-hidden="true">*</span>
  {/if}
</label>
